import { createSlice } from "@reduxjs/toolkit";
import { getMonthsAgo } from "helpers/dates";
import { isBlank } from "helpers/strings";
import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import {
    DefaultFilterState,
    DateRadio,
    DefaultInputFilter,
    DefaultProvinceFilter
} from 'redux/global.consts';

export const dashboardFilterSlice = createSlice({
    name: "dashboardFilter",
    initialState: Object.assign({}, DefaultFilterState),
    reducers: {
        pickFromDate: (state, data) => {
            state.pickedDateFrom = data.payload;
            if (state.selectedRadio === DateRadio.CustomDate) {
                state.fromDate = data.payload;
            }
        },
        pickToDate: (state, data) => {
            state.pickedDateTo = data.payload;
            if (state.selectedRadio === DateRadio.CustomDate) {
                state.toDate = data.payload;
            }
        },
        handleInputChange: (state, data) => {
            state.selectedInput = data.payload;
        },
        handleProvinceChange: (state, data) => {
            state.selectedProvince = data.payload;
        },
        handleDateRadioChange: (state, data) => {
            const radioId = data.payload;

            state.selectedRadio = radioId;

            let from, to;
            switch (radioId) {
                case DateRadio.LastMonth:
                    from = getMonthsAgo(1).toISOString();
                    to = new Date().toISOString();
                    break;
                case DateRadio.LastThreeMonths:
                    from = getMonthsAgo(3).toISOString();
                    to = new Date().toISOString();
                    break;
                case DateRadio.CustomDate:
                    from = state.pickedDateFrom;
                    to = state.pickedDateTo;
                    break;
                default:
                //stuff
            }

            state.fromDate = from;
            state.toDate = to;
        },
        buildFiltersQuery: (state, _) => {
            let buysReportFilter = '?all_items=true&';
            let distsReportFilter = '?all_items=true&';
            let productsReportFilter = '?all_items=true&';
            let storesReportFilter = '?all_items=true&';

            if (!isBlank(state.fromDate)) {
                const formattedString = new DateObject(new Date(state.fromDate))
                    .convert(gregorian, gregorian_en)
                    .toUTC()
                    .format("YYYY-MM-DD");

                buysReportFilter += `start_date=${formattedString}&`;
                distsReportFilter += `start_date=${formattedString}&`;
                productsReportFilter += `start_date=${formattedString}&`;
            }
            if (!isBlank(state.toDate)) {
                const formattedString = new DateObject(new Date(state.toDate))
                    .convert(gregorian, gregorian_en)
                    .toUTC()
                    .format("YYYY-MM-DD");

                buysReportFilter += `end_date=${formattedString}&`;
                distsReportFilter += `end_date=${formattedString}&`;
                productsReportFilter += `end_date=${formattedString}&`;
            }
            if (state.selectedInput.value > 0) {
                buysReportFilter += `input_id=${state.selectedInput.value}&`;
                distsReportFilter += `input_id=${state.selectedInput.value}&`;
                productsReportFilter += `input_id=${state.selectedInput.value}&`;
                storesReportFilter += `input_id=${state.selectedInput.value}&`;
            } else if (state.selectedInput.value === null) {
                // if state.selectedInput.value === null then filter type is concentrate
                buysReportFilter += `input_id=null&`;
                distsReportFilter += `input_id=null&`;
                productsReportFilter += `input_id=null&`;
                storesReportFilter += `input_id=null&`;
              }
            if (state.selectedProvince && state.selectedProvince?.value > 0) {
                buysReportFilter += `province_id=${state.selectedProvince.value}&`;
                distsReportFilter += `province_id=${state.selectedProvince.value}&`;
                productsReportFilter += `province_id=${state.selectedProvince.value}&`;
                storesReportFilter += `province_id=${state.selectedProvince.value}&`;
            }

            state.buysReportFilter = `${buysReportFilter}`;
            state.distsReportFilter = `${distsReportFilter}`;
            state.productsReportFilter = `${productsReportFilter}`;
            state.storesReportFilter = `${storesReportFilter}`;
        },
        resetAllFilters: (state, _) => {
            const from = new DateObject(getMonthsAgo(1))
                .convert(gregorian, gregorian_en)
                .toUTC()
                .format("YYYY-MM-DD");

            const to = new DateObject(new Date())
                .convert(gregorian, gregorian_en)
                .toUTC()
                .format("YYYY-MM-DD");


            state.fromDate = from;
            state.toDate = to;
            state.selectedInput = DefaultInputFilter;
            state.selectedProvince = DefaultProvinceFilter;
            state.pickedDateFrom = from;
            state.pickedDateTo = to;
            state.selectedRadio = DateRadio.LastMonth;
            state.buysReportFilter = `?start_date=${from}&end_date=${to}&all_items=true&`;
            state.distsReportFilter = `?start_date=${from}&end_date=${to}&all_items=true&`;
            state.productsReportFilter = `?start_date=${from}&end_date=${to}&all_items=true&`;
            state.storesReportFilter = `?all_items=true&`;
        },
    },
});

export const {
    handleDateRadioChange,
    pickFromDate,
    pickToDate,
    handleInputChange,
    buildFiltersQuery,
    resetAllFilters,
    handleProvinceChange,
} = dashboardFilterSlice.actions;
export default dashboardFilterSlice.reducer;
